import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSEO } from '../../hooks/useSEO';
import { buildBreadcrumbJsonLd } from '../../config/seo';
import ServiceCard from '../../components/ServiceCard/ServiceCard';
import BlobDecoration from '../../components/BlobDecoration/BlobDecoration';
import { services } from '../../data/services';
import { Language } from '../../routes/routeConfig';
import styles from './Services.module.css';

const Services: React.FC = () => {
  const { t, i18n } = useTranslation();

  const seo = useSEO({
    titleKey: 'seo.services.title',
    descriptionKey: 'seo.services.description',
    routeKey: 'services',
    structuredData: buildBreadcrumbJsonLd(
      [
        { name: t('nav.home'), routeKey: 'home' },
        { name: t('nav.services'), routeKey: 'services' },
      ],
      i18n.language as Language
    ),
  });

  return (
    <div className={styles.services}>
      {seo}
      <section className={styles.header}>
        <BlobDecoration color="blue" position="top-right" size="md" />
        <BlobDecoration color="red" position="bottom-left" size="sm" />
        <div className="container">
          <h1 className={styles.pageTitle}>{t('services.pageTitle')}</h1>
          <p className={styles.pageSubtitle}>{t('services.pageSubtitle')}</p>
        </div>
      </section>

      <section className={styles.listSection}>
        <div className="container">
          <div className={styles.grid}>
            {services.map((service) => (
              <ServiceCard key={service.id} service={service} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
